import React from "react";
import styles from "./FeedbackEmotionCard.module.scss";
import clsx from "clsx";

const FeedbackEmotionCard = ({
  inputID,
  emotionRating,
  emotionRatingList,
  updateEmotionRatingFormData,
}) => {
  const { rating, name, description, isSelected, imageSrc } = emotionRating;

  return (
    <div
      className={
        isSelected
          ? clsx(styles.containerWrapper, styles.borderRing)
          : styles.containerWrapper
      }
      onClick={() =>
        updateEmotionRatingFormData({
          inputID,
          rating,
          [inputID]: emotionRatingList,
        })
      }
    >
      <div className={styles.container}>
        {name && (
          <p className={clsx(styles.cardText, styles.cardTitle)}>{name}</p>
        )}
        <img
          src={imageSrc}
          alt={description}
          style={
            name
              ? { maxWidth: "48px" }
              : { paddingTop: "10px", paddingBottom: "8px", maxWidth: "48px" }
          }
        />
        <p className={clsx(styles.cardText, styles.cardDescription)}>
          {description}
        </p>
      </div>
    </div>
  );
};

export default FeedbackEmotionCard;
